import { ADAPTIVE_SCANNING_ENABLED_FLAG } from '@terra/shared-contracts-feature-flags';
import {
  resolveHomeScanningStatus,
  type HomeScanningStatus,
} from '../../components/dashboard/home-scanning-status';
import { useAdaptiveScanningState } from '../api/useAdaptiveScanningState';
import { useApplicationById } from '../api/useApplicationById';
import { useFeatureFlags } from '../useFeatureFlags';

export function useHomeScanningStatus(applicationId: string): {
  status: HomeScanningStatus | null;
  executionsEnabled: boolean;
  crawlerEnabled: boolean;
} {
  const { isFeatureFlagEnabled } = useFeatureFlags(
    ADAPTIVE_SCANNING_ENABLED_FLAG,
  );
  const { data: adaptiveState } = useAdaptiveScanningState({
    applicationId,
    enabled: isFeatureFlagEnabled,
  });
  const { application } = useApplicationById({ id: applicationId });

  if (!application) {
    return { status: null, executionsEnabled: false, crawlerEnabled: false };
  }

  const executionsEnabled = application.smokeTestEnabled ?? false;

  return {
    status: resolveHomeScanningStatus({ adaptiveState, executionsEnabled }),
    executionsEnabled,
    crawlerEnabled: application.crawlerPeriodic?.enabled ?? false,
  };
}
